import type { Components, Theme } from '@mui/material';

import { colors } from '../tokens';

export const MuiMenuItem: Components<Theme>['MuiMenuItem'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing(1),
      borderRadius: theme.spacing(0.75),
      fontSize: theme.typography.pxToRem(16),
      color: colors.black[950],
      margin: theme.spacing(0, 0),
      gap: theme.spacing(1),

      '& .MuiListItemIcon-root': {
        minWidth: 'auto',
      },

      // Reset MUI's built-in margin on a Divider that follows a MenuItem —
      // vertical spacing is handled centrally by the MuiMenu list `gap`.
      '& + .MuiDivider-root': {
        marginTop: 0,
        marginBottom: 0,
      },

      '&:hover': {
        backgroundColor: colors.gray[50],
        ...theme.applyStyles('dark', {
          backgroundColor: colors.grayTrue[850],
        }),
      },

      '&.Mui-selected': {
        backgroundColor: colors.gray[50],

        '&:hover': {
          backgroundColor: colors.gray[50],
          ...theme.applyStyles('dark', {
            backgroundColor: colors.grayTrue[850],
          }),
        },

        ...theme.applyStyles('dark', {
          backgroundColor: colors.grayTrue[850],
        }),
      },

      ...theme.applyStyles('dark', {
        color: colors.black[25],
      }),
    }),
  },
};
